import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import StudentRouteAdd from "./StudentRouteAdd";
import StudentRouteStore from "../store/StudentRouteStore";
import CompanyAutocomplete from "./CompanyAutocomplete";

class StudentRouteList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.companyStore = new CompanyStore(this);
    this.studentRouteStore = new StudentRouteStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openStudentRouteForm: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_ROUTE_NAME_"),
        dataIndex: "routeName",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                // this.props.canUpdate('taxiTypeList') &&
                this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: context.translate("_AREA_"),
        dataIndex: "areaName",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
        render: (areas) => areas?.join(", "),
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 30,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {
                  // this.props.canUpdate('taxiTypeList') &&
                  <Tooltip
                    title={context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                }
                {
                  // this.props.canDelete('taxiTypeList') &&
                  <Tooltip
                    title={context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                }
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 ||
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.handleSearch();
      this.setState({ pageSize: 50, loadData: 1 });
    }
  }

  onEdit = async (record) => {
    await this.setState({ routeId: record.routeId });
    await this.setState({ openStudentRouteForm: true });
  };

  async onDelete(record) {
    // console.log("record", record);
    const response = await this.studentRouteStore.deleteRecord({
      routeId: record.routeId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.studentRouteStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  closeModal = () => {
    this.setState({ openStudentRouteForm: false });
  };

  responseMsg = async (resp) => {
    console.log("object", resp);
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openStudentRouteForm: false });
      await this.handleSearch();
    } else {
      message.error(this.context.translate(resp.message));
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.studentRouteStore.loadData({
      offset: 0,
      limit: 50,
      companyId: this.state.companyId,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("taxiTypeList") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      openStudentRouteForm: true,
                      routeId: "",
                    })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.studentRouteStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.studentRouteStore?.routelist}
            loading={this.studentRouteStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openStudentRouteForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openStudentRouteForm}
            footer={false}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            title={
              <div className="formTitle">
                {this.context.translate("_ROUTE_")}
                <p className="formDescription">
                  {this.context.translate("_ROUTE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openStudentRouteForm: false })}
            onCancel={() =>
              this.setState({
                openStudentRouteForm: false,
                routeId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <StudentRouteAdd
                routeId={this.state.routeId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
StudentRouteList.contextType = StoreContext;
export default observer(withRouter(StudentRouteList));
